import React, { useState, useEffect } from 'react';

const withDelayWrapper = <T,>(Component: React.FC<T>, delay = 100): any => {
  return (props: React.PropsWithChildren<T>) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
      setTimeout(() => {
        setShow(true);
      }, delay);

      return () => {
        setShow(false);
      };
    }, [delay]);

    if (!show) return null;

    return <Component {...props} />;
  };
};

export default withDelayWrapper;
